// Dev-mode bootstrap. When the page loads with `?dev=1` (or VITE_DEV_AUTO_LOGIN=true)
// we inject a synthetic Supabase session into localStorage BEFORE supabase-js
// initializes. The backend pair is `DEV_FAKE_AUTH=true` which accepts any token
// (or none) and returns DEV_USER_ID. End result: no Supabase project needed for
// local poking-around.

import { supabase } from './supabase'

const DEV_USER_ID = '00000000-0000-0000-0000-000000000001'

const FAKE_JWT =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9' +
  '.eyJzdWIiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDEiLCJlbWFpbCI6ImRldkBsb2NhbC50ZXN0IiwiYXVkIjoiYXV0aGVudGljYXRlZCJ9' +
  '.dev-mode-signature-ignored-by-backend-when-DEV_FAKE_AUTH-true'

function buildSession() {
  return {
    access_token: FAKE_JWT,
    token_type: 'bearer',
    expires_in: 31_536_000,                                    // 1 year
    expires_at: Math.floor(Date.now() / 1000) + 31_536_000,
    refresh_token: 'dev-rt',
    user: {
      id: DEV_USER_ID,
      email: 'dev@local.test',
      aud: 'authenticated',
      role: 'authenticated',
      app_metadata: { provider: 'dev' },
      user_metadata: { display_name: 'Dev User' },
    },
  }
}

function findSbKey() {
  for (const k of Object.keys(localStorage)) {
    if (k.startsWith('sb-') && k.endsWith('-auth-token')) return k
  }
  return 'sb-placeholder-auth-token'
}

export function maybeBootstrapDevSession() {
  const params = new URLSearchParams(window.location.search)
  const auto = import.meta.env.VITE_DEV_AUTO_LOGIN === 'true'
  const requested = params.has('dev') || params.get('dev') === '1' || auto

  if (!requested) return false

  const key = findSbKey()
  const existing = localStorage.getItem(key)
  // Already authed via dev? keep.
  try {
    if (existing) {
      const parsed = JSON.parse(existing)
      if (parsed?.user?.id === DEV_USER_ID) return true
    }
  } catch { /* fall through */ }

  const session = buildSession()
  localStorage.setItem(key, JSON.stringify(session))

  // Push the session into the live client so React reacts immediately.
  supabase.auth.setSession({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
  }).catch(() => { /* placeholder URL → setSession fails but session is in storage */ })

  console.info('[dev] Synthetic dev session injected. user_id =', DEV_USER_ID)
  return true
}
